module.exports = __webpack_public_path__ + "img/peseta-sign.381e8401.svg";